/**
 * Token Refresh Timer Manager
 * Extracted from authService.ts
 * Manages automatic token refresh scheduling
 */

import { log } from "@/shared/utils/logger";

export class TokenRefreshTimer {
  private refreshTimer: NodeJS.Timeout | null = null;

  /**
   * Set up automatic token refresh
   * Refreshes 2 minutes before expiry (minimum 30 seconds)
   */
  setupRefresh(expiresIn: number, refreshCallback: () => Promise<unknown>): void {
    // Clear any existing timer
    this.clear();

    // Refresh 2 minutes before expiry (access tokens last 15 minutes)
    const refreshDelay = Math.max((expiresIn - 120) * 1000, 30000); // At least 30 seconds

    this.refreshTimer = setTimeout(async () => {
      log.info("TokenRefreshTimer", "Auto-refreshing access token...");
      try {
        await refreshCallback();
      } catch (error) {
        log.error("TokenRefreshTimer", "Auto-refresh failed:", error);
        // Do not automatically clear tokens here
      }
    }, refreshDelay);

    log.debug(
      "TokenRefreshTimer",
      `Token refresh scheduled in ${refreshDelay}ms (${Math.floor(refreshDelay / 1000)}s)`
    );
  }

  /**
   * Clear the refresh timer
   */
  clear(): void {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  }

  /**
   * Check if refresh timer is active
   */
  isActive(): boolean {
    return this.refreshTimer !== null;
  }
}
